export default __webpack_public_path__ + "static/media/Blend-on.0c8ef103.svg";